import React from "react"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  const navigate = useNavigate()
  return (
    <div>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h1 className="mb-sm-0 fw-semibold">{props.breadcrumbItem}</h1>
            {/* <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>{props.title}</BreadcrumbItem>
              <BreadcrumbItem active>{props.breadcrumbItem}</BreadcrumbItem>
            </ol>
          </div> */}
          </div>
        </Col>
      </Row>

      {/* back button */}
      {props.back && (
        <Row>
          <Col>
            <button
              className="link primary d-flex align-items-center"
              onClick={() => {
                if (props.backUrl) {
                  navigate(props.backUrl)
                } else {
                  navigate(-1)
                }
              }}
            >
              <i className="mdi mdi-arrow-left me-1"></i>
              {props.back}
            </button>
          </Col>
        </Row>
      )}
    </div>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  back: PropTypes.string,
  backUrl: PropTypes.string,
}

export default Breadcrumb
